import { Modal } from '@material-ui/core';
import { DSModal } from 'designSystem';
import { RewardProgressSection } from 'features/RewardCard/components/RewardProgressSection';
import { RewardModalProps } from 'features/RewardCard/RewardCard.types';
import { getSlipBetTypesLabel } from 'features/RewardCard/utils/utils';
import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

export const RewardModal = memo(({ unlockConditions, openModal, setOpenModal, unlockedSum, unlockedBets }: RewardModalProps) => {
	const { t } = useTranslation();
	const { totalSumToUnlock, totalBetsToUnlock, minimumOddsProduct, allowedSlipBetTypes } = unlockConditions || {};
	const odds = minimumOddsProduct?.toFixed(2);
	const transComponent = { span: <span className="text-gray-900 dark:text-white" /> };
	const closeModal = () => setOpenModal(false);
	const depositCondition = totalSumToUnlock && !totalBetsToUnlock;
	const betsCondition = !totalSumToUnlock && totalBetsToUnlock;
	const bothConditions = totalSumToUnlock && totalBetsToUnlock;
	const noRewardConditions = !totalSumToUnlock && !totalBetsToUnlock; // just for the first month of implementing RewardCard feature. Condition made for old bonuses so that an action occurs after clicking use button

	const slipBetTypes = getSlipBetTypesLabel(t, allowedSlipBetTypes);

	return (
		<Modal
			className="flex items-center justify-center backdrop-blur-sm"
			open={openModal}
			onClose={closeModal}
			BackdropProps={{ className: '!bg-black !bg-opacity-50' }}
		>
			<DSModal
				cancelButtonAction={closeModal}
				alignment="left"
				title={t('rewardCardModalTitle')}
				type="info"
				showCloseIcon
				confirmButtonText={t('modalPendingButton')}
				confirmButtonAction={closeModal}
			>
				<div className="text-paragraph-sm text-left">
					<div className=" mb-2">
						{
							<>
								{bothConditions && t('rewardCardModalDescriptionBoth')}
								{betsCondition && t('rewardCard_modalDescriptionBets')}
								{(depositCondition || noRewardConditions) && t('rewardCardModalDescriptionDeposit')}
							</>
						}
					</div>
					{(depositCondition || bothConditions) && (
						<div className=" mb-2">
							<Trans i18nKey={'rewardCardModalDynamicDeposit'} values={{ unlockedSum, totalSumToUnlock }} components={transComponent} />
							{slipBetTypes && (
								<Trans i18nKey={'rewardCardModalDynamicOddsCoupon'} values={{ type: slipBetTypes }} components={transComponent} />
							)}
							{!slipBetTypes && odds && t('rewardCardModalCoupon')}
							{odds && <Trans i18nKey={'rewardCardModalDynamicOdds'} values={{ odds }} components={transComponent} />}
						</div>
					)}

					{(betsCondition || bothConditions) && (
						<div className="mb-2">
							<Trans
								i18nKey={'rewardCardModalDynamicCoupon'}
								values={{ unlockedBets, totalBetsToUnlock, odds }}
								components={transComponent}
							/>
							{slipBetTypes && (
								<Trans i18nKey={'rewardCardModalDynamicOddsCoupon'} values={{ type: slipBetTypes }} components={transComponent} />
							)}
						</div>
					)}

					{!noRewardConditions && <div className=" mb-2">{t('rewardCardModalActual')}</div>}
				</div>
				{unlockConditions && (
					<RewardProgressSection
						separator={false}
						unlockConditions={unlockConditions}
						unlockedBets={unlockedBets}
						unlockedSum={unlockedSum}
					/>
				)}
			</DSModal>
		</Modal>
	);
});
